export default "__VITE_ASSET__BRB0TNUr__"